import {
  LotteryDrawSchema,
  LotterySchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetLotteryDrawParams = Static<typeof GetLotteryDrawParamsSchema>;
export const GetLotteryDrawParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
    lotteryDrawId: LotteryDrawSchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetLotteryDrawParamsSchema' }
);

export type GetLotteryDrawResponse = Static<typeof GetLotteryDrawResponseSchema>;
export const GetLotteryDrawResponseSchema = Type.Object(
  {
    lotteryDraw: LotteryDrawSchema,
  },
  { additionalProperties: false, $id: 'GetLotteryDrawResponseSchema' }
);
